$(function () {
    var $burgerContainer = $(".burger-menu-button");

    $burgerContainer.on("click", function () {

        $(".burger-menu").toggleClass("open");
        $burgerContainer.toggleClass("is-active");
    });

    var resizeTimer,
        $userMenuItems = $(".user-menu"),
        checkIfUserMenuItemsAreWrapped = function () {
            $userMenuItems.each(function () {
                var userMenuItem = $(this);
                userMenuItem.toggleClass("user-menu-wrapped", userMenuItem.offset().top > 0);
            });
        };

    if ($userMenuItems.length) {

        checkIfUserMenuItemsAreWrapped();

        $(window).on("resize", function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(checkIfUserMenuItemsAreWrapped, 50);
        });
    }
});
